'use client';

import { CSSProperties, FC } from 'react';
import GridCard from '@/components/recipes/grid-card/grid-card';
import { richTextToPlain } from '@/utils/rich-text-to-plain';

export interface RecipeCardItem {
  image: string;
  title: string;
  cookingTime?: string;
  richText?: string;
  href: string;
}

export interface RecipeCardGridProps {
  items: RecipeCardItem[];
  paddingStyle?: CSSProperties;
}

const RecipeCardGrid: FC<RecipeCardGridProps> = ({ items, paddingStyle }) => {
  if (items.length === 0) return null;

  return (
    <div className="container mx-auto" style={paddingStyle}>
      <div className="grid grid-cols-1 gap-8 @sm:grid-cols-2 @lg:grid-cols-3 @xl:grid-cols-4">
        {items.map((item, index) => (
          <GridCard
            key={index}
            image={item.image}
            date=""
            title={item.title}
            description={richTextToPlain(item.richText ?? '')}
            href={item.href}
            cookingTime={item.cookingTime}
            priority={index === 0}
          />
        ))}
      </div>
    </div>
  );
};

export default RecipeCardGrid;
